/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */

const axios = require("axios");

let url = process.env.REACT_APP_URL

const checkCookies = () => {
    let enabled = navigator.cookieEnabled;
    if(!enabled){
        document.cookie = "test"
        enabled = document.cookie.indexOf("test") !== -1
    }
    return enabled
}

const args = {}
args.withCredentials = true

if(checkCookies()){
    args.headers = {
        common: {
            acceptcookies: true
        }
    }
}
const instance = axios.create(args)


const getFrom = async (path, filters = null, headers= {}) => {
    return instance.get(url+path, {params: filters, headers: headers})
}

const postTo = async (path, data, options = {}) => {
    return instance.post(url+path, data, options)
}

const patchTo = async (path, data, options = {}) => {
    return instance.patch(url+path, data, options)
}

const deleteTo = async (path, options = {}) => {
    return instance.delete(url+path, options)
}

const getUrl = () => {
    return url
}

const addHeaderToRequests = (name, value) => {
    instance.defaults.headers[name] = value;
}

export {getFrom, getUrl, postTo, patchTo, deleteTo, addHeaderToRequests}